"use client";

import { useEffect } from "react";

export function AttributionTracker() {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (document.cookie.includes("cv_attribution=")) return;

    try {
      const params = new URLSearchParams(window.location.search);
      let safeReferrer = "";
      if (document.referrer) {
        try {
          const url = new URL(document.referrer);
          safeReferrer = `${url.origin}${url.pathname}`.slice(0, 500);
        } catch {}
      }

      const value = JSON.stringify({
        landingPage: window.location.pathname.slice(0, 500),
        referrer: safeReferrer,
        utmSource: (params.get("utm_source") || "").slice(0, 120),
        utmMedium: (params.get("utm_medium") || "").slice(0, 120),
        utmCampaign: (params.get("utm_campaign") || "").slice(0, 160),
        utmContent: (params.get("utm_content") || "").slice(0, 160),
        utmTerm: (params.get("utm_term") || "").slice(0, 160),
      });

      const maxAge = 30 * 24 * 60 * 60; // 30 days
      document.cookie = `cv_attribution=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    } catch {}
  }, []);

  return null;
}
